// Config.js
const Config = {
    REACT_APP_API_URL: process.env.NODE_ENV === 'production' ? 'https://residenceit.com/auth/password-resset-confirm' : 'http://localhost:3000/auth/password-resset-confirm',
    // Autres variables d'environnement...
  };
    
export default Config;
  